import { useState } from "react";
import { Column, Columns, Detail, Flex } from "@dna/react";
import { FlatButton, FlatPaginationButton } from "../../common/FlatButton";
import ResidentStatus from "../ResidentStatus";
import ResidentOrganizationAndFacility from "../ResidentOrganizationAndFacility";
import { ResidentNameInput } from "../ResidentNameInput";
import { UserType } from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import { ChartExpiryFilter } from "./ChartExpiryFilter";
import { ChartExpiryType } from "../../../services/medicationmanagement/patientApi/models/ChartExpiryType";
import { FilterActions, OrganizationAndFacilityType } from "./ResidentFilterReducer";
import { StyleProps } from "@dna/react-types";
import { ChartStatusFilterComponent } from './ChartStatusFilter'
import { ChartStatusFilter } from "../../../services/medicationmanagement/patientApi/models/ChartStatusFilter";
import { RenderIf } from "../../common/render-if/RenderIf";
import { IResidentFilter } from "./ResidentFilterReducer";
import { Facilities } from "../../../services/medicationmanagement/facilities/FacilitiesApi";
import { Organization } from "../../../services/medicationmanagement/organization/OrganizationApi";
import {Button} from "@material-ui/core";
import { CourseExpiryFilterSubType, ExpiryFilterType } from "../../../services/medicationmanagement/patientApi/models/ExpiryFilterType";

function PageNumberButton(props: { number: number, selectedLimit: number, handleClick: (itemsPerPage: number) => void }) {
    let paginationbtn: StyleProps = {
        width: "100%"
    };
    if (props.number == props.selectedLimit) {
        return (
            <Button color="primary" variant="contained" disableElevation fullWidth={true}
                onClick={() => props.handleClick(props.number)}>
                {props.number}
            </Button>);
    }
    return (
        <Button color="default" variant="contained" disableElevation fullWidth={true}
                onClick={() => props.handleClick(props.number)}>
            {props.number}
        </Button>
    )
}



export const ResidentFilter = (props: {
    filterState: IResidentFilter;
    filterData?: any;
    userType: UserType;
    facilityData: Facilities[];
    organizationData: Organization[];
    onChange: (action: [type: FilterActions, payload: any]) => void;
}

) => {
    let { total, totalDueNow, totalDueNowAndSoon, searchResults } = props.filterData || {};
    let { key, name, expiryFilterType, courseExpiryFilterSubType, itemsPerPage, residentStatus, chartStatus,facilities } = props.filterState;
    let clrfilterbtn: StyleProps = {
        width: "275px"
    };
    const onNameChanged = (val: string) => {
        props.onChange([FilterActions.ChangeName, val]);
    };

    const onClearFilters = () => {
        let resetChartStatus = props.userType === UserType.Pharmacist?{chartStatus:ChartStatusFilter.WithChanges} : {};
        props.onChange([FilterActions.Clear, resetChartStatus]);
    };

    const onItemsPerPageChanged = (newVal: number) => {
        props.onChange([FilterActions.ChangeItemsPerPage, newVal]);
    };

    const onResidentStatusChanged = (val: string) => {
        props.onChange([FilterActions.ChangeResidentStatus, val]);
    };

    const onChartExpiryChanged = (val: ExpiryFilterType) => {
        if(val !== ExpiryFilterType.CourseDueNowOrSoon){
            props.onChange([FilterActions.ChangeChartExpiry, val]);
        }
        else {
            // The default value for course expiry is 7 days
            props.onChange([FilterActions.CHANGE_CHART_EXPIRY_SUB_FILTER, CourseExpiryFilterSubType.CourseExpiryInSevenDays])
        }
    };

    const onChartExpirySubFilterChanged = (val: CourseExpiryFilterSubType) => {
        props.onChange([FilterActions.CHANGE_CHART_EXPIRY_SUB_FILTER, val])
    };

    const onChartStatusFilterChanged = (val: ChartStatusFilter) => {
        props.onChange([FilterActions.CHANGE_CHART_STATUS, val])
    }
    const onOrganizationFacilityChanged = (facilityType: OrganizationAndFacilityType, val: string|null) => {
        props.onChange([FilterActions.CHANGE_ORGANIZATION_FACILITY, {type:facilityType,id:val}]);
    }
    return (

        <Flex
            css={{
                gap: "medium",
                padding: "small"
            }}
        >
            <Detail
                css={{
                    color: "muted"
                }}
                level="small"
            >
                Resident name
                </Detail>

            {/* Please note that the 'key' attribute is critical to the working of ResidentNameInput */}
            <ResidentNameInput handleChange={onNameChanged} name={name} key={key} />
            <RenderIf if={props.userType === UserType.Pharmacist}>
                <ChartStatusFilterComponent value={chartStatus} onChange={onChartStatusFilterChanged} />
            </RenderIf>

            <ResidentOrganizationAndFacility onOrganizationFacilityChanged={onOrganizationFacilityChanged}
                facilityData={props.facilityData} organizationData={props.organizationData} menuItemState={facilities} />
            <ResidentStatus onResidentStatusChanged={onResidentStatusChanged} state={residentStatus} />
            <ChartExpiryFilter
                expiryType={expiryFilterType}
                courseExpiryFilterSubType={courseExpiryFilterSubType}
                totalChartDueNowAndSoon={0}
                totalCourseDueNowAndSoon={0}
                totalNumberOfResults={0}
                onChange={onChartExpiryChanged}
                onChangeSubFilter={onChartExpirySubFilterChanged}
            />
            <Detail
                css={{
                    color: "muted"
                }}
                level="small"
            >
                Show max results
                </Detail>
            <Columns css={{
                gap: 0
            }}>
                <Column width="1/4">
                    <PageNumberButton number={25} selectedLimit={itemsPerPage} handleClick={onItemsPerPageChanged} />
                </Column>
                <Column width="1/4">
                    <PageNumberButton number={50} selectedLimit={itemsPerPage} handleClick={onItemsPerPageChanged} />
                </Column>
                <Column width="1/4">
                    <PageNumberButton number={75} selectedLimit={itemsPerPage} handleClick={onItemsPerPageChanged} />
                </Column>
                <Column width="1/4">
                    <PageNumberButton number={100} selectedLimit={itemsPerPage} handleClick={onItemsPerPageChanged} />
                </Column>
            </Columns>

            <Button
                color="primary"
                variant={"outlined"}
                fullWidth={true}
                disableElevation={true}
                onClick={onClearFilters}
            >
                Clear all filters
                </Button>

        </Flex>

    );
};
